'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pagination = function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call.apply(_ref, [this].concat(args))), _this), _this.previousRef = _this.previousRef.bind(_this), _this.nextRef = _this.nextRef.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Pagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.previousButton.blur();
      this.nextButton.blur();
    }
  }, {
    key: 'handlePageChange',
    value: function handlePageChange(page) {
      return this.props.action.call(this, page);
    }
  }, {
    key: 'previousRef',
    value: function previousRef(button) {
      this.previousButton = button;
    }
  }, {
    key: 'nextRef',
    value: function nextRef(button) {
      this.nextButton = button;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentPage = _props.currentPage,
          totalPages = _props.totalPages;


      var previousPage = currentPage - 1;
      var nextPage = currentPage + 1;

      var previousProps = {
        className: 'previous',
        disabled: currentPage <= 1,
        action: this.handlePageChange.bind(this, previousPage),
        elementRef: this.previousRef.bind(this),
        iconLeft: 'chevronLeft',
        title: (0, _i18n2.default)('previousPage')
      };

      var nextProps = {
        className: 'next',
        disabled: currentPage >= totalPages,
        action: this.handlePageChange.bind(this, nextPage),
        elementRef: this.nextRef.bind(this),
        iconRight: 'chevronRight',
        title: (0, _i18n2.default)('nextPage')
      };

      return _react2.default.createElement(
        'div',
        { className: 'Pagination' },
        _react2.default.createElement(_Button2.default, previousProps),
        _react2.default.createElement(_Button2.default, nextProps)
      );
    }
  }]);

  return Pagination;
}(_react.Component);

Pagination.propTypes = {
  /** The action to handle page change. */
  action: _propTypes2.default.func.isRequired,
  /** The current page number. */
  currentPage: _propTypes2.default.number.isRequired,
  /** The total number of pages. */
  totalPages: _propTypes2.default.number.isRequired
};
exports.default = Pagination;
Pagination.__docgenInfo = {
  'description': '',
  'methods': [{
    'name': 'handlePageChange',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'page',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'previousRef',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'button',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'nextRef',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'button',
      'type': null
    }],
    'returns': null
  }],
  'displayName': 'Pagination',
  'props': {
    'action': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': 'The action to handle page change.'
    },
    'currentPage': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': 'The current page number.'
    },
    'totalPages': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': 'The total number of pages.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Pagination.js
// module id = 275
// module chunks = 0